import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { BlockStockPage } from '@/components/BlockStock/BlockStockPage'
import { blockStockSearchSchema, withoutBlockStockDefaults } from '@/components/BlockStock/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the page. */
export const Route = createFileRoute('/_app/operations/block-stock/')({
  validateSearch: blockStockSearchSchema,
  component: BlockStockRoute,
})

function BlockStockRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <BlockStockPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutBlockStockDefaults, next, options))
      }
    />
  )
}
